// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
enum VehicleRegisterVehicleFuelType {
  None = "NONE",
  Other = "OTHER",
  Petrol = "PETROL",
  Diesel = "DIESEL",
  BioDiesel = "BIO_DIESEL",
  MixOfPetrolAndOil = "MIX_OF_PETROL_AND_OIL",
  CompressedNaturalGas = "COMPRESSED_NATURAL_GAS",
  LiquefiedNaturalGas = "LIQUEFIED_NATURAL_GAS",
  LiquefiedPetroleumGas = "LIQUEFIED_PETROLEUM_GAS",
  Ethanol85Percent = "ETHANOL85_PERCENT",
  Ethanol95Percent = "ETHANOL95_PERCENT",
  Biomethane = "BIOMETHANE",
  Steam = "STEAM",
  Hydrogen = "HYDROGEN",
  Electricity = "ELECTRICITY",
}
export default VehicleRegisterVehicleFuelType;
